import React from 'react';
import { homeStats } from '../../data/homeContent';

function HomeStats() {
  return (
    <section className="home-stats">
      <div className="container">
        <div className="home-stats-grid">
          {homeStats.map((item) => (
            <article key={item.label} className="home-stat">
              <strong>{item.value}</strong>
              <span>{item.label}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeStats;
